/**
 * Pre-cache configuration
 * Controls visibility-based pre-fetching behavior
 */

export const PRECACHE_CONFIG = {
  enabled: true,
  logEnabled: false, // Toggle for debug console logs

  // Idle detection
  idleThresholdMs: 300,
  scrollDebounceMs: 100,

  // Batch processing
  batchSize: 10,
  batchIntervalMs: 1500,
  maxQueueSize: 50,

  // Priority
  centerBias: 1.5,

  // Rate limiting
  minFetchIntervalMs: 100,
  maxConcurrentFetches: 3,

  // IntersectionObserver
  rootMargin: '100px 0px',
  threshold: 0.1
}

// Item types for pre-caching
export const ITEM_TYPES = {
  review: {
    enabled: true,
    fetchMethod: 'fetchReviewById',
    store: 'storeReviews',
    priority: 1.0
  },
  title: {
    enabled: true,
    fetchMethod: 'fetchTitleById',
    store: 'storeTMDB',
    priority: 0.8
  }
  // Future: list
}
